import React from "react";
import styled from "styled-components";
import { SkeletonBox, SkeletonText, SkeletonCard, SkeletonChip } from "./SkeletonBox";

/**
 * SearchPageSkeleton - Non-animated skeleton for Search page
 * 
 * Matches layout of:
 * - searchContent.js
 * - searchFilters.js
 */

var Container = styled.div`
  padding: 40px;
  min-height: 100vh;
  background-color: #121212;
`;

var SearchInputArea = styled.div`
  margin-bottom: 30px;
`;

var FilterRow = styled.div`
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -moz-box-orient: horizontal;
  -moz-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-bottom: 30px;
`;

var FilterItem = styled.div`
  margin-left: 10px;
  margin-bottom: 10px;
`;

var ResultsGrid = styled.div`
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
  -moz-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
`;

var GridItem = styled.div`
  margin-left: 20px;
  margin-bottom: 20px;
`;

var SearchInputSkeleton = styled.div`
  width: 100%;
  max-width: 500px;
  height: 56px;
  background-color: #262626;
  -webkit-border-radius: 28px;
  -moz-border-radius: 28px;
  border-radius: 28px;
`;

/**
 * Search Input Skeleton
 */
function SearchInputSection() {
  return (
    <SearchInputArea>
      <SearchInputSkeleton />
    </SearchInputArea>
  );
}

/**
 * Filter Chips Row Skeleton
 */
function FilterChipsSkeleton({ count = 4 }) {
  var chips = [];
  var widths = [100, 80, 120, 90];
  
  for (var i = 0; i < count; i++) {
    chips.push(
      <FilterItem key={"filter_" + i}>
        <SkeletonChip width={widths[i % widths.length]} />
      </FilterItem>
    );
  }
  
  return (
    <FilterRow>
      {chips}
    </FilterRow>
  );
}

/**
 * Results Grid Skeleton
 */
function ResultsGridSkeleton({ rows = 3, cols = 4 }) {
  var items = [];
  var total = rows * cols;
  
  for (var i = 0; i < total; i++) {
    items.push(
      <GridItem key={"result_" + i}>
        <SkeletonCard type="portrait" />
      </GridItem>
    );
  }
  
  return (
    <ResultsGrid>
      {items}
    </ResultsGrid>
  );
}

/**
 * SearchPageSkeleton - Main export
 */
function SearchPageSkeleton({ showFilters = true, rows = 3, cols = 4 }) {
  return (
    <Container>
      <SearchInputSection />
      {showFilters && <FilterChipsSkeleton count={4} />}
      <ResultsGridSkeleton rows={rows} cols={cols} />
    </Container>
  );
}

export { SearchInputSection, FilterChipsSkeleton, ResultsGridSkeleton };
export default SearchPageSkeleton;
